import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom"
import App from "./App";
import {AuthProvider, AuthProviderProps} from "react-oidc-context";
import "@fontsource/titillium-web";
import {createTheme, ThemeProvider} from "@mui/material";
import {User} from "oidc-client-ts";
import {SnackbarProvider} from "notistack";
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterLuxon} from '@mui/x-date-pickers/AdapterLuxon'
import {Settings} from "luxon";
import './global.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
declare module '@mui/material/styles' {
    interface Theme {
        violet: {
            main: string;
        };
    }

    // allow configuration using `createTheme`
    interface ThemeOptions {
        violet?: {
            main?: string;
        };
    }
}


const theme = createTheme({
    typography: {
        fontFamily: '"Titillium Web",sans-serif',
    },
    palette: {
        primary: {
            "main": "#000094"
        },
        secondary: {
            main: "#B900FF"
        }
    }
})

const oidcConfig: AuthProviderProps = {
    authority: "https://auth.gaia-x.eu/realms/gaia-x/",
    client_id: "temporary-token",
    redirect_uri: `${document.location.origin}`,
    scope: "openid email profile groups",
    onSigninCallback: (_user: User | void): void => {
        window.history.replaceState(
            {},
            document.title,
            window.location.pathname
        )
    }

};
Settings.defaultLocale = "fr-BE";
root.render(
    <React.StrictMode>
        <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="fr" >
            <SnackbarProvider maxSnack={3}>
                <ThemeProvider theme={theme}>
                    <AuthProvider {...oidcConfig}>
                        <BrowserRouter>
                            <App></App>
                        </BrowserRouter>
                    </AuthProvider>
                </ThemeProvider>
            </SnackbarProvider>
        </LocalizationProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();